import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedRoutingModule } from './shared-routing.module';
import { SpinnerComponent } from './spinner/spinner.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmComponent } from './confirm/confirm.component';
import { NgbdModalConfirmComponent } from './ngbd-modal-confirm/ngbd-modal-confirm.component';

// providers should never be placed in a shared module.
@NgModule({
  declarations: [SpinnerComponent, NgbdModalConfirmComponent],
  imports: [    
    CommonModule,
    SharedRoutingModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SpinnerComponent
  ]
})
export class SharedModule { }
